"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_PRICE_OWNER = void 0;
exports.PRODUCT_PRICE_OWNER = {
    CAMPAIGN: 'CAMPAIGN',
    LANDING: 'LANDING'
};
//# sourceMappingURL=productPriceOwner.js.map